/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon64Regular = forwardRef('CheckCircleCutIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M26.683 9.623a23 23 0 0 1 14.066 1.106 1.5 1.5 0 0 0 1.142-2.774A26 26 0 1 0 57.83 34.969a1.5 1.5 0 0 0-2.98-.342A23 23 0 1 1 26.682 9.623Z" }),
        React.createElement("path", { d: "M56.56 16.56a1.5 1.5 0 1 0-2.12-2.12L32.974 35.903a3.5 3.5 0 0 1-4.95 0l-7.964-7.965a1.5 1.5 0 0 0-2.122 2.122l7.965 7.964a6.5 6.5 0 0 0 9.192 0l21.465-21.464Z" })));
});
